export default __webpack_public_path__ + "images/c7b81d4b2d5367bdc947557a624aabc6-talkToSomeoneIcon.svg";